import script from "./LearningSetupSummaryChoicesSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./LearningSetupSummaryChoicesSection.vue?vue&type=script&setup=true&lang=ts"

import "./LearningSetupSummaryChoicesSection.vue?vue&type=style&index=0&id=9f4a733a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f4a733a"]])

export default __exports__